<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>营销</el-breadcrumb-item>
            <el-breadcrumb-item>分销</el-breadcrumb-item>
            <el-breadcrumb-item>商品设置</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="dis-flex">
            <div class="second-swaper">
                <second></second>
            </div>
            <div class="flex-box" style="overflow-x: hidden">
                <Card :bordered="false" dis-hover class="ivu-mt">
                    <Form class="form mt30" ref="formValidate" :rules="ruleValidate" :model="formValidate"  @on-validate="validate"
                          :label-width="labelWidth" :label-position="labelPosition" @submit.native.prevent>
                        <Col span="24">
                            <FormItem label="" prop="">
                                <el-table
                                        :data="[goods]"
                                        style="width: 100%">
                                    <el-table-column
                                            prop="goods_id"
                                            width="80"
                                            label="商品ID">
                                    </el-table-column>
                                    <el-table-column
                                            width="80"
                                            label="商品图">
                                        <template slot-scope="scope">
                                            <viewer>
                                                <div class="tabBox_img">
                                                    <img v-lazy="scope.product_pic_main" />
                                                </div>
                                            </viewer>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            width="300"
                                            prop="name"
                                            label="商品名称">
                                    </el-table-column>
                                    <el-table-column
                                            width="80"
                                            prop="stock_total"
                                            label="库存总量">
                                    </el-table-column>
                                </el-table>
                            </FormItem>
                        </Col>
                        <Col span="24">
                            <FormItem label="佣金规则：" prop="is_ind_dealer">
                                <div class="acea-row row-middle">
                                    <RadioGroup element-id="is_ind_dealer"  v-model="formValidate.is_ind_dealer">
                                        <Radio :label="1" class="radio">单独设置</Radio>
                                        <Radio :label="0">默认规则</Radio>
                                    </RadioGroup>
                                </div>
                            </FormItem>
                        </Col>
                        <Col span="24" v-if="formValidate.is_ind_dealer == 1">
                            <FormItem label="分销佣金类型：" prop="dealer_money_type">
                                <div class="acea-row row-middle">
                                    <RadioGroup element-id="dealer_money_type"  v-model="formValidate.dealer_money_type">
                                        <Radio :label="10" class="radio">百分比</Radio>
                                        <Radio :label="20">固定金额</Radio>
                                    </RadioGroup>
                                </div>
                            </FormItem>
                            <FormItem label="规格选择：">
                                <Table
                                        ref="selection"
                                        :data="specsData"
                                        :columns="columns"
                                        border>
                                    <template slot-scope="{ row, index }" slot="goods_props">
                                    <span>
                                        {{row.sku_name}}
                                    </span>
                                    </template>
                                    <template slot-scope="{ row, index }" slot="first_money">
                                        <InputNumber v-model="specsData[index].first_money"></InputNumber>
                                        <span style="margin-left: 10px">{{formValidate.dealer_money_type == 10 ? '%' : '元'}}</span>
                                    </template>
                                    <template slot-scope="{ row, index }" slot="second_money">
                                        <InputNumber v-model="specsData[index].second_money"></InputNumber>
                                        <span style="margin-left: 10px">{{formValidate.dealer_money_type == 10 ? '%' : '元'}}</span>
                                    </template>
                                    <template slot-scope="{ row, index }" slot="third_money">
                                        <InputNumber v-model="specsData[index].third_money"></InputNumber>
                                        <span style="margin-left: 10px">{{formValidate.dealer_money_type == 10 ? '%' : '元'}}</span>
                                    </template>
                                </Table>
                            </FormItem>
                        </Col>
                        <div class="clearfix"></div>
                        <FormItem>
                            <Button type="primary" :disabled="submitOpen" class="submission" @click="submit('formValidate')" v-text="'保存'"></Button>
                        </FormItem>
                    </Form>
                </Card>
            </div>
        </div>
    </div>
</template>

<script>
    import second from "../second.vue";
    export default {
        name: "add",
        components: { second },
        computed: {
            labelWidth () {
                return 135;
            },
            labelPosition () {
                return 'right';
            }
        },
        data () {
            return {
                isLoad: false,
                submitOpen: false,
                spinShow: false,
                formValidate: {
                    goods_id: 0,
                },
                ruleValidate: {

                },
                model: false,
                goods: false,
                columns: [
                    {
                        title: "规格",
                        align: 'center',
                        slot: "goods_props",
                        width: 120,
                    },
                    {
                        title: "分销商等级",
                        align: 'center',
                        key: "level_name",
                        width: 120,
                    },
                    {
                        title: "原价",
                        align: 'center',
                        key: "price",
                        minWidth: 150,
                    },
                    {
                        title: "一级分销",
                        align: 'center',
                        minWidth: 100,
                        slot: 'first_money'
                    },
                    {
                        title: "二级分销",
                        align: 'center',
                        minWidth: 100,
                        slot: 'second_money'
                    },
                    {
                        title: "三级分销",
                        align: 'center',
                        minWidth: 100,
                        slot: 'third_money'
                    },
                ],
                specsData: [],
            }
        },
        mounted () {
            this.getInfo();
        },
        methods: {
            // 详情
            getInfo () {
                this.spinShow = true;
                this.axios.post('/store/app.dealer.goods/detail',{
                    goods_id: this.$route.query.id
                }).then(async res => {
                    this.spinShow = false;
                    if (res.code == 1) {
                        this.model = res.data.model
                        this.goods = res.data.goods
                        this.formValidate = {
                            goods_id: this.model.goods_id,
                            is_ind_dealer: this.model.is_ind_dealer,
                            dealer_money_type: this.model.dealer_money_type,
                        }
                        this.specsData = res.data.specData
                    } else {
                        this.$message.error(res.msg);
                    }
                }).catch(res => {
                    this.spinShow = false;
                    this.$Message.error(res.msg);
                })
            },
            // 表单验证
            validate (prop, status, error) {
                if (status === false) {
                    this.$Message.error(error);
                }
            },
            submit: function (name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        var flag = true
                        this.specsData.forEach(function (item) {
                        })

                        if (!flag) {
                            return false;
                        }

                        this.formValidate.skuList = JSON.parse(JSON.stringify(this.specsData))
                        this.submitOpen = true;
                        this.axios.post('/store/app.dealer.goods/edit',{
                            form: this.formValidate,
                            goods_id: this.$route.query.id
                        }).then(async res => {
                            this.submitOpen = false;
                            if (res.code == 1) {
                                this.$Message.success(res.msg);
                                setTimeout(() => {
                                    this.$router.push({ path: '/app/dealer/goods.html' });
                                }, 500);
                            } else {
                                this.$Message.error(res.msg);
                            }
                        }).catch(res => {

                        })
                    } else {
                        return false;
                    }
                })
            }
        }

    }
</script>

<style scoped>

</style>
